import * as Yup from 'yup';

export const invalidReferenceNoMsg = 'TAS Reference/BOL/Load ID can only contain up to 7 numeric digits. Try again.';

export const initialValues = {
  ReferenceNo: '',
  LoadingPlant: '',
  Vehicle: '',
  Photo: '',
};

// Function to validate file extensions
export const validateFileType = (file) => {
  const EXTENSIONS = ['.jpg', '.jpeg'];
  if ((file && file.name)) {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    return EXTENSIONS.includes(`.${fileExtension}`);
  }
  if ((file && !file.name)) {
    const fileExtension = file.split('.').pop().toLowerCase();
    return EXTENSIONS.includes(`.${fileExtension}`);
  }
  return false;
};

export const CreateOpenOrderSchema = Yup.object().shape({
  ReferenceNo: Yup.string()
    .required()
    .matches(/^[0-9]{1,7}$/, invalidReferenceNoMsg)
    .label('TAS Reference/BOL/Load ID'),
  LoadingPlant: Yup.string()
    .required()
    .label('Loading Plant'),
  Vehicle: Yup.string()
    .required()
    .label('Vehicle Number'),
  // Photo field is not validated with Yup
  // Listing it here to represent the open order structure
  Photo: Yup.mixed()
    .label('BOL Photo')
    .test(
      'fileExtension',
      'Only jpg or .jpeg files are allowed. Please try again.',
      value => {
       if (!value || value.length === 0) return true;  // Skip validation if no file is selected
        return validateFileType(value); // VAlidate file type
      }
    ),
});
